$(document).ready(function () {
  $(".variant-picker__option input").click(function() {
     var buttonVariant = $(this).closest('.variant-picker__option').attr('button-variant');
    console.log(buttonVariant)
     $(".product-media-variant").css('display', 'none');
     $(".product-media-variant[product-image-variant='" + buttonVariant + "']").css('display', 'block');
  });
});

window.onload = function () {
  if (document.getElementsByClassName("shopify-payment-button").length) {
    document
      .getElementsByClassName("shopify-payment-button")[0]
      .addEventListener("click", function (e) {
        e.preventDefault();
        document.getElementsByClassName("main-product-form")[0].submit();
      });
  }

  if (document.getElementsByClassName("product-option-item").length) {
    var options = Array.from(
      document.getElementsByClassName("product-option-item")
    );
    var tags = Array.from(document.getElementsByClassName("tagsDiscount"));
    options.forEach((element) => {
      if (
        document.getElementsByClassName("discount_" + element.innerText).length
      ) {
        element.addEventListener("click", function () {
          tags.forEach((element) => (element.style.display = "none"));
          document.getElementsByClassName(
            "discount_" + element.innerText
          )[0].style.display = "block";
        });
      }
    });
  }

  if (document.getElementsByClassName("sf-pqv__button").length) {
    var quickViews = Array.from(
      document.getElementsByClassName("sf-pqv__button")
    );
    quickViews.forEach((element) => {
      element.addEventListener("click", function () {
        var checker = setInterval(function () {
          if (document.getElementsByClassName("product-option-item").length) {
            var options = Array.from(
              document.getElementsByClassName("product-option-item")
            );
            var tags = Array.from(
              document.getElementsByClassName("tagsDiscount")
            );
            options.forEach((element) => {
              if (
                document.getElementsByClassName("discount_" + element.innerText)
                  .length
              ) {
                element.addEventListener("click", function () {
                  tags.forEach((element) => (element.style.display = "none"));
                  document.getElementsByClassName(
                    "discount_" + element.innerText
                  )[0].style.display = "block";
                });
              }
            });
            clearInterval(checker);
          }
        }, 50);
      });
    });
  }

  document.addEventListener("click", function (e) {
    const target = e.target;
    if (
      target.classList.contains("close") &&
      target.closest(".warningMessage")
    ) {
      removeWarningMessage(500);
    }
  });

  /*if (document.body.classList.contains('template-index')) {
    var language = document.documentElement.getAttribute('lang');
  
    switch (language) {
      case 'es':
        showWarningMessage("Debido a las restricciones de tráfico causadas por las Jornadas Mundiales de la Juventud, no podemos garantizar las entregas en el área de Lisboa entre el 31 de julio y el 6 de agosto. Los pedidos se entregarán la semana siguiente. Gracias por entender.");
        break;
      case 'fr':
        showWarningMessage("En raison des contraintes de circulation causées par les Journées Mondiales de la Jeunesse, nous ne sommes pas en mesure de garantir les livraisons dans la région de Lisbonne entre le 31 juillet et le 6 août. Les commandes seront livrées la semaine suivante. Merci de votre compréhension.");
        break;
      case 'en':
        showWarningMessage("Due to traffic constraints caused by the World Youth Days, we can’t guarantee deliveries in Lisbon between July 31st and August 6th. Orders will be delivered the following week. Thank you for understanding.");
        break;
      default:
        showWarningMessage("Devido aos condicionamentos de trânsito provocados pelas Jornadas Mundiais da Juventude, não conseguimos garantir entregas na zona de Lisboa entre 31 de Julho e 6 de Agosto. As encomendas serão entregues na semana seguinte. Agradecemos a compreensão.");
    }
  }*/
};

function showWarningMessage(msg) {
  var modalHTML = "";
  modalHTML += "<div class='warningMessage'>";
  modalHTML += "<div class='modal_align'>";
  modalHTML += "<a class='close'>×</a>";
  modalHTML += '<div class="loading_modal_content" style="text-align:center">';
  modalHTML += '<span class="msg">' + msg + "</span>";
  modalHTML += "</div></div></div>";
  document.body.classList.add("overflow_hidden");
  document.body.insertAdjacentHTML("afterbegin", modalHTML);
}

function removeWarningMessage(time) {
  const warningMessage = document.querySelector(".warningMessage");
  if (warningMessage) {
    setTimeout(() => {
      warningMessage.style.display = "none";
    }, time);
  }

  setTimeout(() => {
    document.body.classList.remove("overflow_hidden");
  }, 1000);
}
